export const PDF_PREVIEW_ID: string = "pdf-preview";
export const WORKER_BASE_URL: string = "https://event-application.null-988.workers.dev/";
